module.exports = __webpack_public_path__ + "static/img/13_2.ced82a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/13_2.jpg
// module id = 4TCF
// module chunks = 0